import { amenityTypeCrudConfig } from '@/config/objects/amenity-types';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Amenity Types list page
 */
export function AmenityTypesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Amenity Types', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={amenityTypeCrudConfig} baseUrl="/amenity-types" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
